const { requestAnimationFrame: raf } = window

let scrollState = 0
let listener
let activeTarget = null

export default {
  bind(el, binding, vnode) {
    let running = false
    if (!running) {
      listener = () => {
        let { targets, direction } = binding.value
        let scrollVal = 0
        let values = targets.map(target => {
          if (typeof target === 'number') {
            return target
          }
          scrollVal += document.querySelector(target)[ direction === 'x' ? 'offsetWidth' : 'offsetHeight' ]
          return scrollVal
        })
        raf(() => {
          const newScrollVal = direction === 'y' ? el.scrollTop : el.scrollLeft
          const diff = scrollState - newScrollVal
          let _activeTarget = null
          if (diff < 0) {
            // 向下滚
            values.reduce((prev, next, index) => {
              if (newScrollVal >= prev && newScrollVal < next) {
                _activeTarget = targets[index]
              }
              if (_activeTarget && activeTarget !== _activeTarget) {
                activeTarget = _activeTarget
                vnode.context.$emit('change', _activeTarget, index)
              }
              return next
            })
          } else {
            if (newScrollVal === 0) {
              _activeTarget = targets[0]
              activeTarget = _activeTarget
              vnode.context.$emit('change', _activeTarget, 0)
            }
            values.reduce((prev, next, index) => {
              if (newScrollVal <= prev) {
                _activeTarget = targets[index]
                return null
              }
              if (_activeTarget && activeTarget !== _activeTarget) {
                activeTarget = _activeTarget
                vnode.context.$emit('change', _activeTarget, index)
              }
              return next
            })
          }
          scrollState = newScrollVal
        })
      }
      el.addEventListener('scroll', listener)
    }
  },
  unbind(el, binding) {
    el.removeEventListener('scroll', listener)
  }
}



// WEBPACK FOOTER //
// ./src/directives/scroll-spy.js